/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const CdsCategoriaR = t.interface({});

// optional attributes
const CdsCategoriaO = t.partial({
  description: t.string,

  id: t.Integer
});

export const CdsCategoria = t.intersection(
  [CdsCategoriaR, CdsCategoriaO],
  "CdsCategoria"
);

export type CdsCategoria = t.TypeOf<typeof CdsCategoria>;
